import React from "react"

import { Card, CardItem, Skeleton } from "@walmart-web/livingdesign-components"
import { SkeletonVariant } from "@walmart-web/livingdesign-components/Skeleton/Skeleton"

import "./SummaryTableSkeleton.scss"

interface SummaryTableSkeletonProps {
	iterate?: number
	type?: SymbolTypes
}

export type SymbolTypes = "simple" | "donut"

const records = Array.from({ length: 3 }, (x, index) => index)

const configSymbol = {
	simple: {
		variant: "rectangle",
		height: 56,
		width: 110,
	},
	donut: {
		variant: "rounded",
		height: 150,
		width: 150,
	},
}

const SummaryTableSkeleton: React.FC<SummaryTableSkeletonProps> = (props) => {
	const { iterate = 1, type = "simple" } = props
	return (
		<>
			{Array.from(Array(iterate).keys()).map((index) => (
				<Card key={index} role="skeletonview" className="skeleton-container">
					<CardItem className="card-item">
						<div className="card-body">
							<Skeleton variant="rectangle" height={28} width={200} />
						</div>
					</CardItem>
					<CardItem className="card-item">
						<div className="card-body metric-chart-skeleton">
							<Skeleton
								variant={configSymbol[type].variant as SkeletonVariant}
								height={configSymbol[type].height}
								width={configSymbol[type].width}
							/>
						</div>
					</CardItem>
					<CardItem className="card-item">
						<div className="card-header">
							<div className="table-header table-row summary-row-data">
								{records.map((index) => (
									<Skeleton
										key={`column-header-${index}`}
										variant="rounded"
										height={30}
									/>
								))}
							</div>
						</div>

						<div className="card-body ">
							{records.map((index) => {
								return (
									<div
										key={`row-${index}`}
										className="table-row summary-row-data"
									>
										<Skeleton variant="rounded" height={30} />
										<Skeleton variant="rounded" height={30} />
										<Skeleton variant="rounded" height={30} />
									</div>
								)
							})}
						</div>
					</CardItem>
				</Card>
			))}
		</>
	)
}

export default SummaryTableSkeleton
